import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FeatureTableHeaderCell from './FeatureTableHeaderCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const THead = styled.thead.withConfig({
  displayName: "FeatureTableHead__THead",
  componentId: "sc-2jx78k-0"
})(["height:155px;& tr th:first-of-type{font-size:1.5rem;font-weight:600;text-align:left;border:none !important;}th{vertical-align:bottom;box-shadow:none;}"]);
const FeatureTableHead = ({
  headerData
}) => {
  const levels = Object.keys(headerData);
  return /*#__PURE__*/_jsx(THead, {
    "data-test-id": "feature-table-head",
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("th", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.featureTable.tableHeader.features"
        })
      }), levels.map(level => {
        const levelData = headerData[level];
        if (!levelData) {
          return /*#__PURE__*/_jsx("th", {});
        }
        const {
          Content
        } = levelData;
        return /*#__PURE__*/_jsx(FeatureTableHeaderCell, {
          level: level,
          totalLevels: levels.length,
          Content: Content
        }, level);
      })]
    })
  });
};
export default FeatureTableHead;